import fetchHandler from "../../utils/fetchHandler";
import { EXERCISES } from "../types/actions";

export const getExercises = (queryString) => {
	const fetchOptions = {
		url: `/api/exercises${queryString}`,
		method: "GET",
		actionType: EXERCISES.GET_EXERCISES
	};
	return fetchHandler(fetchOptions);
};

export const getExerciseFilters = () => {
	const fetchOptions = {
		url: `/api/exercise_filters`,
		method: "GET",
		actionType: EXERCISES.GET_EXERCISE_FILTERS
	};
	return fetchHandler(fetchOptions);
};

export const getExerciseDetails = (id) => {
	const fetchOptions = {
		url: `/api/exercises/${id}`,
		method: "GET",
		actionType: EXERCISES.EXERCISE_DETAILS
	};
	return fetchHandler(fetchOptions);
};

export const searchExercises = (queryString) => {
	const fetchOptions = {
		url: `/api/exercises?${queryString}`,
		method: "GET",
		actionType: EXERCISES.SEARCH_EXERCISES
	};
	return fetchHandler(fetchOptions);
};

export const getPotentialBurnData = (id) => {
	const fetchOptions = {
		url: `/api/exercises/${id}/potential_burn/`,
		method: "GET",
		actionType: EXERCISES.EXERCISE_POTENTIAL_BURN
	};
	return fetchHandler(fetchOptions);
};

export const getRelatedExercises = (id) => {
	const fetchOptions = {
		url: `/api/exercises/${id}/related_exercises/`,
		method: "GET",
		actionType: EXERCISES.EXERCISE_RELATED
	};
	return fetchHandler(fetchOptions);
};

export const addExerciseToMyWorkout = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans/bulk_create`,
		method: "POST",
		actionType: EXERCISES.ADD_EXERCISE_TO_WORKOUT,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const addPlanToMyWorkout = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans`,
		method: "POST",
		actionType: EXERCISES.ADD_PLAN_TO_WORKOUT,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const editExerciseSchedule = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans/${values.id}`,
		method: "PUT",
		actionType: EXERCISES.EDIT_EXERCISE,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const deleteExerciseFromPlan = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/member_exercise_plans/${values.id}/`,
		method: "DELETE",
		actionType: EXERCISES.DELETE_EXERCISES_FROM_PLAN
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const logExercise = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/log_exercises`,
		method: "POST",
		actionType: EXERCISES.LOG_EXERCISE,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const editExercise = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/log_exercises/${values.id}`,
		method: "PUT",
		actionType: EXERCISES.EDIT_EXERCISE_SUMMARY,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const deleteExerciseFromHistory = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/log_exercises/${values.id}`,
		method: "DELETE",
		actionType: EXERCISES.DELETE_EXERCISE_SUMMARY,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const logExerciseAll = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/log_exercises/bulk_create/`,
		method: "POST",
		actionType: EXERCISES.LOG_EXERCISE_ALL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};
